import { render, staticRenderFns } from "./BrandAccesses.vue?vue&type=template&id=7c10de86&"
import script from "./BrandAccesses.vue?vue&type=script&lang=js&"
export * from "./BrandAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BrandAccesses.vue"
export default component.exports